/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filled_StarInputs */

const en_common_filled_star = /** @type {(inputs: Common_Filled_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filled star`)
};

const es_common_filled_star = /** @type {(inputs: Common_Filled_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrella rellena`)
};

/**
* | output |
* | --- |
* | "Filled star" |
*
* @param {Common_Filled_StarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_filled_star = /** @type {((inputs?: Common_Filled_StarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filled_StarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_filled_star(inputs)
	return en_common_filled_star(inputs)
});